import dayjs, { type ConfigType } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/ru";

// Все даты в приложении показываем в таймзоне Алматы (+5), независимо от
// таймзоны браузера пользователя. Сервер отдаёт время в RFC3339 со смещением
// (напр. 2026-07-12T05:00:00Z), поэтому .tz корректно переводит момент в
// местное время Алматы для отображения — без двойного сдвига.
export const APP_TIMEZONE = "Asia/Almaty";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(APP_TIMEZONE);
dayjs.locale("ru");

/** Оборачивает значение в dayjs, привязанный к таймзоне Алматы. */
export const dt = (value?: ConfigType) => dayjs(value).tz(APP_TIMEZONE);

/** «DD.MM.YYYY HH:mm» в таймзоне Алматы. Пустое значение → «—». */
export const formatDateTime = (value?: ConfigType | null): string =>
  value ? dt(value).format("DD.MM.YYYY HH:mm") : "—";

/** «DD.MM.YYYY» в таймзоне Алматы. Пустое значение → «—». */
export const formatDate = (value?: ConfigType | null): string =>
  value ? dt(value).format("DD.MM.YYYY") : "—";

// Границы суток для фильтров по дате. Дату «YYYY-MM-DD» из инпута читаем как
// стенные часы Алматы (dayjs.tz, а не dt) — иначе в браузере с далёким
// смещением день уехал бы на соседний. Отдаём ISO со смещением: сервер парсит
// его как RFC3339 и не зависит от своей таймзоны.

/** Начало суток «YYYY-MM-DD» в Алматы → «2026-07-01T00:00:00+05:00». */
export const startOfDayISO = (date: string): string =>
  dayjs.tz(date, APP_TIMEZONE).startOf("day").format();

/** Конец суток «YYYY-MM-DD» в Алматы → «2026-07-01T23:59:59+05:00». */
export const endOfDayISO = (date: string): string =>
  dayjs.tz(date, APP_TIMEZONE).endOf("day").format();

export { dayjs };
